<template>
  <div :class="$style.suspend">
    <Suspend @close="close" ref="suspendRef" ></Suspend>
  </div>
</template>
<script>
import Suspend from "@/components/Suspend/index.vue";

export default {
  data() {
    return {
    }
  },
  async mounted() {
    // 获取礼包数据
    this.$store.dispatch('suspend/getGiftData');
     // 判断福利红点用
    const appkey = this.$getStorage('appkey');
    const user_id = this.$getStorage('user_id');
    const { role } = this.$store.state.redEnvelope;
    this.$store.dispatch('redEnvelope/getReceiveInfo', {
      params: {
        appkey,
        user_id,
        server_num: role.server_num,
        role_id: role.role_id,
      },
      fail: () => {},
    });
  },
  components: {
    Suspend
  },
  methods: {
    close() {
      // this.$refs.suspendRef.setSideBarState(false);
      setTimeout(() => {
        this.$store.commit('user/CHANGE_STATE', { floatWindowVisible: false });
      }, 800);
    }
  }
}
</script>
<style lang="scss" module>
.suspend {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: $float-window;
}
</style>